(() => {
  const recurringClosures = new Set(['01-01', '04-23', '05-01', '05-19', '07-15', '08-30', '10-28', '10-29']);
  const datedClosures = new Set([
    '2026-03-19', '2026-03-20', '2026-03-21', '2026-03-22',
    '2026-05-26', '2026-05-27', '2026-05-28', '2026-05-29', '2026-05-30',
    '2027-03-08', '2027-03-09', '2027-03-10', '2027-03-11',
    '2027-05-15', '2027-05-16', '2027-05-17', '2027-05-18', '2027-05-19',
    '2028-02-25', '2028-02-26', '2028-02-27', '2028-02-28',
    '2028-05-04', '2028-05-05', '2028-05-06', '2028-05-07', '2028-05-08'
  ]);
  const dayFormatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit'
  });
  const dateFormatters = new Map();
  const instances = new Set();
  const daysForItems = () => 2;
  const istanbulDay = now => {
    const parts = Object.fromEntries(dayFormatter.formatToParts(now).map(part => [part.type, part.value]));
    return new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day), 12));
  };
  const arrival = (days, now = new Date()) => {
    const date = istanbulDay(now);
    let remaining = 2;
    while (remaining > 0) {
      date.setUTCDate(date.getUTCDate() + 1);
      const key = date.toISOString().slice(0, 10);
      if (date.getUTCDay() !== 0 && !recurringClosures.has(key.slice(5)) && !datedClosures.has(key)) remaining -= 1;
    }
    return date;
  };
  const clockFormatter = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Istanbul', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  const openDay = date => {
    const key = date.toISOString().slice(0, 10);
    return date.getUTCDay() !== 0 && !recurringClosures.has(key.slice(5)) && !datedClosures.has(key);
  };
  const dispatch = (days, now = new Date()) => {
    const date = istanbulDay(now);
    const clock = Object.fromEntries(clockFormatter.formatToParts(now).map(p => [p.type, p.value]));
    const minutes = Number(clock.hour) * 60 + Number(clock.minute);
    const sameDay = openDay(date) && minutes < 660;
    if (!sameDay) date.setUTCDate(date.getUTCDate() + 1);
    while (!openDay(date)) date.setUTCDate(date.getUTCDate() + 1);
    const deadline = date.getTime() - 4 * 60 * 60 * 1000;
    return { date, remaining: Math.max(1, Math.ceil((deadline - now.getTime()) / 60000)) };
  };
  window.KcDelivery = Object.freeze({ daysForItems, arrival, dispatch });
  class KcDeliveryEstimate extends HTMLElement {
    static get observedAttributes() { return ['data-days']; }
    connectedCallback() {
      instances.add(this);
      this.render();
    }
    disconnectedCallback() { instances.delete(this); }
    attributeChangedCallback() { if (this.isConnected) this.render(); }
    render() {
      const target = this.querySelector('[data-kc-delivery-date]');
      if (!target) return;
      const now = new Date();
      const shipment = dispatch(this.dataset.days, now);
      const dispatchTarget = this.querySelector('[data-kc-dispatch]');
      const locale = this.dataset.locale || 'tr';
      if (!dateFormatters.has(locale)) dateFormatters.set(locale, new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric', month: 'long', weekday: 'long' }));
      if (dispatchTarget) {
        const difference = Math.round((shipment.date - istanbulDay(now)) / 86400000);
        const label = difference === 0 ? this.dataset.today : difference === 1 ? this.dataset.tomorrow : dateFormatters.get(locale).format(shipment.date);
        const countdown = this.querySelector('[data-kc-countdown]');
        countdown.replaceChildren();
        if (shipment.remaining) {
          const count = document.createElement('span');
          count.className = 'kc-dispatch__count';
          const hours = Math.floor(shipment.remaining / 60);
          const minutes = shipment.remaining % 60;
          count.textContent = (hours ? hours + ' ' + this.dataset.hour + ' ' : '') + (minutes ? minutes + ' ' + this.dataset.minute : '');
          countdown.append(count, document.createTextNode(' ' + this.dataset.orderWithin + ' '));
        }
        this.querySelector('[data-kc-dispatch-day]').textContent = label;
        this.querySelector('[data-kc-dispatch-suffix]').textContent = ' ' + this.dataset.dispatch;
        dispatchTarget.hidden = false;
      }
      const date = arrival(this.dataset.days, now);
      const key = date.toISOString().slice(0, 10);
      if (target.dataset.date === key && target.dataset.locale === locale) return;
      if (!dateFormatters.has(locale)) dateFormatters.set(locale, new Intl.DateTimeFormat(locale, { timeZone: 'UTC', day: 'numeric', month: 'long', weekday: 'long' }));
      const time = document.createElement('time');
      time.dateTime = key;
      time.textContent = dateFormatters.get(locale).format(date);
      target.replaceChildren(document.createTextNode(this.dataset.label + ' '), time, document.createTextNode(this.dataset.suffix ? ' ' + this.dataset.suffix : ''));
      target.dataset.date = key;
      target.dataset.locale = locale;
    }
  }
  if (!customElements.get('kc-delivery-estimate')) customElements.define('kc-delivery-estimate', KcDeliveryEstimate);
  const refresh = () => { for (const instance of instances) instance.render(); };
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  let rolloverTimer;
  const scheduleRollover = () => {
    window.clearTimeout(rolloverTimer);
    const now = new Date();
    const nextMidnight = istanbulDay(now).getTime() + 9 * 60 * 60 * 1000;
    rolloverTimer = window.setTimeout(() => { refresh(); scheduleRollover(); }, Math.max(1000, nextMidnight - now.getTime() + 1000));
  };
  scheduleRollover();
  window.setInterval(() => { if (!document.hidden) refresh(); }, 15000);
})();

